import React, { useState, useMemo } from "react";
import { useScheduleData } from "./ScheduleDataContext";

export default function ScheduleFilters() {
  const {
    filters, setFilters,
    filteredAssignments, assignments,
    allTicketStatuses, selectedTicketStatuses, setSelectedTicketStatuses,
  } = useScheduleData();
  const count = filteredAssignments ? filteredAssignments.length : (assignments ? assignments.length : 0);

  const [statusOpen, setStatusOpen] = useState(false);
  const [statusQ, setStatusQ] = useState("");

  const visibleStatuses = useMemo(() => {
    const q = statusQ.trim().toLowerCase();
    if (!q) return allTicketStatuses;
    return allTicketStatuses.filter(s => s.toLowerCase().includes(q));
  }, [allTicketStatuses, statusQ]);

  function toggleStatus(name) {
    setSelectedTicketStatuses(prev => {
      const next = prev.includes(name) ? prev.filter(s => s !== name) : [...prev, name];
      return next;
    });
  }

  const selectedStatusSet = new Set(selectedTicketStatuses);
  const statusLabel = selectedTicketStatuses.length === 0
    ? "Status"
    : selectedTicketStatuses.length === 1
      ? selectedTicketStatuses[0]
      : `Status (${selectedTicketStatuses.length})`;

  return (
    <div style={{
      display: 'flex',
      gap: 12,
      alignItems: 'flex-end',
      flexWrap: 'wrap',
      padding: '8px 12px',
      marginBottom: 8,
      border: '1px solid #e0e0e0',
      borderRadius: 6,
      background: 'var(--blue_accent)',
      color: 'var(--white_coordinating)'
    }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label style={{ fontSize: 12, opacity: 0.9 }}>Project #</label>
        <input
          type="text"
          value={filters.project}
          onChange={(e) => setFilters(f => ({ ...f, project: e.target.value }))}
          placeholder="e.g. 12345 or 123,456,789"
          style={{ padding: '6px 8px', minWidth: 200 }}
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label style={{ fontSize: 12, opacity: 0.9 }}>Ticket ID</label>
        <input
          type="text"
          value={filters.ticket}
          onChange={(e) => setFilters(f => ({ ...f, ticket: e.target.value }))}
          placeholder="e.g. 56789"
          style={{ padding: '6px 8px', minWidth: 160 }}
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label style={{ fontSize: 12, opacity: 0.9 }}>Resource</label>
        <input
          type="text"
          value={filters.resource}
          onChange={(e) => setFilters(f => ({ ...f, resource: e.target.value }))}
          placeholder="name contains…"
          style={{ padding: '6px 8px', minWidth: 200 }}
        />
      </div>
      {/* Ticket Status multi-select */}
      <div style={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
        <label style={{ fontSize: 12, opacity: 0.9 }}>Ticket Status</label>
        <button
          onClick={() => setStatusOpen(o => !o)}
          style={{
            padding: '6px 10px',
            minWidth: 160,
            textAlign: 'left',
            background: '#fff',
            color: '#000',
            border: '1px solid #ccc',
            borderRadius: 4,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 8,
          }}
        >
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {statusLabel}
          </span>
          <span style={{ fontSize: 10 }}>{statusOpen ? '▲' : '▼'}</span>
        </button>
        {statusOpen && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            zIndex: 200,
            background: '#fff',
            color: '#000',
            border: '1px solid #ccc',
            borderRadius: 4,
            boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
            minWidth: 220,
            maxWidth: 320,
            marginTop: 2,
          }}>
            <div style={{ padding: '6px 8px', borderBottom: '1px solid #eee' }}>
              <input
                autoFocus
                placeholder="Search statuses…"
                value={statusQ}
                onChange={e => setStatusQ(e.target.value)}
                style={{ width: '100%', padding: '4px 6px', border: '1px solid #ccc', borderRadius: 4, fontSize: 13 }}
              />
            </div>
            <div style={{ maxHeight: 240, overflowY: 'auto' }}>
              {allTicketStatuses.length === 0 && (
                <div style={{ padding: '8px 12px', fontSize: 13, opacity: 0.6 }}>No statuses loaded yet</div>
              )}
              {visibleStatuses.length === 0 && allTicketStatuses.length > 0 && (
                <div style={{ padding: '8px 12px', fontSize: 13, opacity: 0.6 }}>No matches</div>
              )}
              {visibleStatuses.map(name => (
                <label key={name} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 12px', cursor: 'pointer', fontSize: 13, color: '#000' }}>
                  <input
                    type="checkbox"
                    checked={selectedStatusSet.has(name)}
                    onChange={() => toggleStatus(name)}
                    style={{ cursor: 'pointer' }}
                  />
                  {name}
                </label>
              ))}
            </div>
            {selectedTicketStatuses.length > 0 && (
              <div style={{ padding: '6px 8px', borderTop: '1px solid #eee' }}>
                <button
                  onClick={() => setSelectedTicketStatuses([])}
                  style={{ fontSize: 12, background: 'none', border: 'none', color: '#1565c0', cursor: 'pointer', padding: 0 }}
                >
                  Clear selection
                </button>
              </div>
            )}
          </div>
        )}
      </div>
      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8 }}>
        <button onClick={() => { setFilters({ project: '', ticket: '', resource: '' }); setSelectedTicketStatuses([]); }}>Clear</button>
        <span style={{ fontSize: 12, opacity: 0.85 }}>Showing {count}</span>
      </div>
    </div>
  );
}
